import { makeStyles } from "@material-ui/core";

const textStyle = makeStyles((theme) => ({
  // Text
  text1: {
    ...theme.typography.body1,
  },
  text2: {
    ...theme.typography.body2,
    margin: 0,
    padding: 0,
  },
  text3: {
    ...theme.typography.body3,
  },
  text4: {
    ...theme.typography.h1,
  },
  heading2: {
    ...theme.typography.h2,
    fontWeight: 500,
  },
  errorText: {
    color: "#f44336",
    margin: 0,
    marginLeft: `14px`,
    marginRight: `14px`,
  },
  textUpper: {
    textTransform: "uppercase",
  },
  textCapitalize: {
    textTransform: "capitalize",
  },
  textSm: {
    fontSize: 11,
  },
  textMd: {
    fontSize: 12,
  },

  // Text

  // Header
  header1: {
    ...theme.typography.h1,
    ...theme.typography.semiBold,
    display: "block",
  },
  header2: {
    ...theme.typography.h2,
    ...theme.typography.semiBold,
    display: "block",
  },
  headerWrap: {
    ...theme.borderBottom,
    paddingBottom: 12,
    marginBottom: 12,
  },
  headerLG: {
    ...theme.typography.hlg,
    ...theme.typography.semiBold,
  },
  headerXL: {
    ...theme.typography.hxl,
    ...theme.typography.semiBold,
  },
  // Modal
  modalHeader: {
    ...theme.typography.h2,
    ...theme.typography.semiBold,
  },
  modalHeadWrap: {
    padding: "4px 16px",
    ...theme.borderBottom,
  },

  // Table
  tableLable: {
    ...theme.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px",
  },
  tableHeader: {
    ...theme.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px",
    fontWeight: 800,
  },

  // Form
  lable: {
    ...theme.typography.body1,
    ...theme.typography.semiBold,
    display: "block",
    textTransform: "capitalize",
    paddingBottom: 4,
  },
  value: {
    ...theme.typography.body1,
    textWrap: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  //
  lableMargin: {
    margin: `18px 0px`,
  },
  textMT: {
    marginTop: 18,
  },
  textMB: {
    marginBottom: 18,
  },
  textPT: {
    paddingTop: 8,
  },
  textPB: {
    paddingBottom: 8,
  },
  textMBSm: {
    marginBottom: 8,
  },
  textFaded: {
    color: "#72757b",
    margin: 0,
  },
  infoText: {
    color: "#6e6c6c",
    ...theme.typography.body2,
    fontStyle: "italic",
    marginTop: "12px",
    textAlign: "right",
  },
  clearLink: {
    textDecoration: "none",
    color: "inherit",
  },

  // Weight
  bold: {
    ...theme.typography.bold,
  },
  semibold: {
    ...theme.typography.semiBold,
  },
  pointer: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },

  //
  alignRight: {
    textAlign: "right",
  },
  alignCenter: {
    textAlign: "center",
  },

  //
  textWhite: {
    color: "#fff",
  },
}));

export default textStyle;
